import {defaultFontFamily, FontFamilyValue} from './fontFamilyHelpers';
import {defaultFontSize} from './fontSizeHelpers';

/*
 * Types.
 */

export type HtmlStyle = {
  isBold?: boolean;
  isItalic?: boolean;
  hasUnderline?: boolean;
  hasStrikethrough?: boolean;
  textColor?: string;
  highlightColor?: string;
  fontFamily?: FontFamilyValue;
  fontSize?: number;
};

/*
 * Constants.
 */

/** App default style, not to be confused with the teammate default style preference. */
export const defaultHtmlStyle: HtmlStyle = {
  isBold: false,
  isItalic: false,
  hasUnderline: false,
  hasStrikethrough: false,
  textColor: '#000',
  highlightColor: '',
  fontFamily: defaultFontFamily,
  fontSize: defaultFontSize,
};
